var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block-wrapper",class:{'-header-scroll-up': _vm.hideHeader}},_vm._l((_vm.blockList),function(block,index){return _c('div',{key:index,class:[
      ("-" + (_vm.getBlockType(block))),
      {
        '-bgcolor': _vm.hasBackgroundColor(block) || block.DarkMode,
        '-blank':
          !(_vm.hasBackgroundColor(block) || block.DarkMode || _vm.darkMode) &&
          !(
            _vm.getBlockType(block) === 'HeroBlock' ||
            _vm.getBlockType(block) === 'TestimonialSliderBlock' ||
            _vm.getBlockType(block) === 'FabricTechnologyBlock' ||
            _vm.getBlockType(block) === 'HighlightBanner' ||
            _vm.getBlockType(block) === 'TabWrapperBlock'
          ),
        '-fullimage':
          _vm.getBlockType(block) === 'HeroBlock' ||
          _vm.getBlockType(block) === 'TestimonialSliderBlock' ||
          _vm.getBlockType(block) === 'FabricTechnologyBlock' ||
          _vm.getBlockType(block) === 'CSRBlock' ||
          _vm.getBlockType(block) === 'TabWrapperBlock' ||
          _vm.getBlockType(block) === 'B2BDigitalWorkbookBlock' ||
          _vm.getBlockType(block) === 'ProductsInActionBlock',

          '-header-no-scroll': _vm.staticHeader
      } ],style:(_vm.blockStyle(block)),attrs:{"id":("block-" + (block.__id__))}},[(_vm.isVisible(block))?_c('div',{class:[
        _vm.container(block),
        {
          '-inline': _vm.inline,
          'content-area':
            _vm.getBlockType(block) !== 'ProductFeatureBlock' &&
            _vm.getBlockType(block) !== 'ProductTechBlock' &&
            _vm.getBlockType(block) !== 'TabWrapperBlock',
          grid: _vm.getBlockType(block) === 'FactoryBlock',
        } ]},[_c(_vm.getBlockType(block),{tag:"component",attrs:{"rowid":("" + index),"index":index,"typeIndex":_vm.similarBlockCount(block),"settings":_vm.settings(block),"model":block,"inline":_vm.inline,"ready":true,"pageType":_vm.pageType,"blockIsScrolledTo":_vm.scrollToBlockIndex === index,"h1Title":!_vm.isStartPage && index === 0,"category":_vm.category,"listName":(_vm.pageType + ": " + _vm.category),"customData":_vm.customData,"graymode":_vm.darkMode},on:{"ready":function($event){return _vm.firstComponentReady(index === 0 || index === 1)},"on-change":function($event){return _vm.$emit('on-change', $event)}}})],1):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }